<!-- 首页-问题反馈-页面级 -->
<template>
  <div class='feedback'>
    <div class='content-wrap'>
      <div class='content'>
        <h3>问题反馈</h3>
        <p class='con-top'>在再来人辅导留学申请中，您有关于MSP的任何问题，请在此处反馈！我们非常重视您的反馈！</p>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate"
              :label-width="100">
          <div class='base-form-item'>
            <FormItem label="问题类型："
                      prop="questionType"
                      key='questionType'
                      ref='questionType'>
              <Select v-model="formValidate.questionType"
                      placeholder="请选择问题类型"
                      clearable>
                <Option v-for="item in questionTypeMap"
                        :key="item[0]"
                        :value="item[0]">{{item[1]}}</Option>
              </Select>
            </FormItem>
            <FormItem label="问题描述："
                      prop="description"
                      key='description'>
              <Input type='textarea'
                     :rows='5'
                     v-model='formValidate.description'
                     placeholder="请输入问题描述" />
            </FormItem>
          </div>
          <div class='oper-sub'>
            <a href='javascript:void(0)'
               @click="questionSubmit">确认提交</a>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { questionTypeMap } from './constants'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 问题类型
      questionTypeMap,
      // 表单
      formValidate: {
        questionType: '',
        description: ''
      },
      ruleValidate: {
        questionType: [
          { required: true, message: '请选择问题类型' }
        ],
        description: [
          { required: true, message: '请输入问题描述', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 确认提交
    questionSubmit () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$refs.formValidate.resetFields()
        } else {

        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.feedback {
  width: 1240px;
  padding: 20px;
  margin: 0 auto;
  .content-wrap {
    background: #fff;
    padding: 40px 180px;
    .content {
      font-size: 14px;
      color: #667483;
      letter-spacing: 0;
      line-height: 26px;
      h3 {
        font-size: 18px;
        color: #323c47;
        letter-spacing: 0;
        text-align: center;
        padding-bottom: 40px;
      }
      .con-top {
        padding-bottom: 20px;
        text-align: center;
      }
      .oper-sub {
        text-align: right;
        a {
          display: inline-block;
          width: 100px;
          height: 36px;
          background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
          border-radius: 8px;
          border-radius: 8px;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
